import React from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";

const SettingMenuTabComponent = ({
  tab,
  selectedTab,
  onSelectTab,
  styles,
  toggleMenu,
}) => {
  return (
    <TouchableOpacity
      key={tab.key}
      style={[
        styles.buttonStyle,
        {
          backgroundColor:
            selectedTab === tab.key
              ? AppColors.grayColor_D9D9D9
              : "transparent",
        },
      ]}
      onPress={() => {
        onSelectTab(tab.key);
        toggleMenu();
      }}
    >
      <View style={styles.buttonInner}>
        {/* <View style={styles.topLineStyle} /> */}
        <Text
          style={[
            styles.buttonTextStyle,
            AppFontStyle.BOLD_ANYBODY_14,
            {
              color:
                selectedTab === tab.key ? AppColors.black : AppColors.white,
              // borderBottomColor:
              //   selectedTab === tab.key
              //     ? AppColors.blue_165AB8
              //     : AppColors.white,
              // borderBottomWidth: 1,
            },
          ]}
        >
          {tab.label}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default SettingMenuTabComponent;
